<template>
  <div>
    <v-data-table
      :page="table.page"
      :headers="headers"
      :items="table.items"
      :items-per-page="table.itemsPerPage"
      :loading="loading.table"
      :server-items-length="table.totalCount"
      :footer-props="{
        'items-per-page-options': table.itemsPerPageOptions,
      }"
      :options.sync="table.options"
      v-if="table.items.length > 0 || loading.table"
      class="d-table"
      @update:options="optionsUpdated"
    >
      <template v-slot:[`item.name`]="{ item }">
        <span class="mr-2">{{ item.name }}</span>
        <v-tooltip right color="primary" v-if="item.isStatic">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" size="22" dark v-bind="attrs" v-on="on">
              mdi-shield-lock
            </v-icon>
          </template>
          <span>{{ $t("roles.list.table.is-static") }}</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex align-center justify-end">
          <v-tooltip top color="gray darken-2" v-granted="'role:delete'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="gray darken-2"
                icon
                small
                v-if="!item.isStatic"
                @click="deleteItem(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon size="18"> mdi-delete </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("roles.list.table.actions.delete") }}</span>
          </v-tooltip>

          <v-tooltip top color="gray darken-2" v-granted="'role:edit'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="gray darken-2"
                icon
                small
                @click="addOrEditItem(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon size="18"> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("roles.list.table.actions.edit") }}</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <d-page-empty
      :createButtonPermission="'role:add'"
      @actionClick="addOrEditItem()"
      :text="$t('roles.list.empty-page')"
      :createButtonText="$t('roles.button.create-item')"
      v-if="!table.isSearched && table.totalCount == 0 && !loading.table"
    >
    </d-page-empty>
    <d-no-result
      v-if="table.isSearched && table.totalCount == 0 && !loading.table"
    ></d-no-result>
  </div>
</template>

<script>
import tableMixins from "@/mixins/tableMixins";
import { mapActions, mapGetters } from "vuex";

export default {
  mixins: [tableMixins],
  data(vm) {
    return {
      headers: [
        {
          text: vm.$t("roles.list.table.headers.name"),
          value: "name",
          sortable: true,
        },
        {
          text: vm.$t("roles.list.table.headers.display-name"),
          value: "displayName",
          sortable: true,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
      initialSearchParams: {},
    };
  },
  computed: {
    ...mapGetters({
      searchParams: "SearchParams/getSearchParams",
    }),
  },
  methods: {
    ...mapActions({
      setSearchParams: "SearchParams/setSearchParams",
    }),
    initSearchParams() {
      this.setSearchParams({ ...this.initialSearchParams });
    },
    handleFetchItems(isSearchCleared = false) {
      if (isSearchCleared) this.initSearchParams();

      this.table.options.page = 1;
      this.table.page = 1;
      this.fetchItems();
    },
    addOrEditItem(item = null) {
      this.$emit("editItem", item);
    },
    deleteItem(item = null) {
      this.$emit("deleteItem", item);
    },
    fetchItems() {
      this.loading.table = true;
      this.table.isSearched = !this.isObjectEmpty(this.searchParams);
      window.API.fetchRoles({
        limit: this.table.itemsPerPage,
        offset: (this.table.page - 1) * this.table.itemsPerPage,
        sortedBy: this.table.sortedBy,
        sortedDesc: this.table.sortedDesc,
        ...this.searchParams,
      })
        .then((response) => {
          this.table.items = response.items;
          this.table.totalCount = response.totalCount;

          if (
            response.totalCount <=
            (this.table.options.page - 1) * this.table.itemsPerPage
          ) {
            this.table.options.page = 1;
          }
        })
        .catch(() => {
          this.showFetchRequestErrorMessage();
        })
        .finally(() => {
          this.loading.table = false;
        });
    },
  },
  created() {
    this.$eventBus.$on("fetchRoles", this.handleFetchItems);
  },
  mounted() {
    this.initSearchParams();
    this.fetchItems();
  },
  beforeDestroy() {
    this.$eventBus.$off("fetchRoles", this.handleFetchItems);
  },
};
</script>
